import { NotFoundPage } from "./pages/NotFoundPage";
import { ProjectDetailPage } from "./pages/ProjectDetailPage";
import { AboutSection } from "./sections/AboutSection";
import { ContactSection } from "./sections/ContactSection";
import { ExperienceSection } from "./sections/ExperienceSection";
import { HeroSection } from "./sections/HeroSection";
import { MarqueeSection } from "./sections/MarqueeSection";
import { MethodSection } from "./sections/MethodSection";
import { ProjectsSection } from "./sections/ProjectsSection";
import { CapabilitiesSection } from "./sections/ServicesSection";
import { projects } from "./content/portfolio";

function LandingPage() {
  return (
    <div className="min-h-screen overflow-x-clip bg-ink text-mist">
      <a className="skip-link" href="#hero-content">
        跳到主要内容
      </a>
      <main id="main-content" tabIndex={-1}>
        <HeroSection />
        <MarqueeSection />
        <AboutSection />
        <CapabilitiesSection />
        <ExperienceSection />
        <ProjectsSection />
        <MethodSection />
        <ContactSection />
      </main>
    </div>
  );
}

export default function App() {
  const path = window.location.pathname.replace(/\/+$/, "") || "/";
  if (path === "/" || path === "/index.html") return <LandingPage />;

  const projectMatch = path.match(/^\/projects\/([^/]+)$/);
  if (projectMatch) {
    const project = projects.find(({ slug }) => slug === projectMatch[1]);
    if (project) return <ProjectDetailPage project={project} />;
  }

  return <NotFoundPage />;
}
